import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		fill: "none",
		width: 24,
		height: 24
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("circle", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			cx: 12,
			cy: 12,
			r: 11.2
		}),
		/* @__PURE__ */ _jsx("line", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			x1: 7.5,
			y1: 16.5,
			x2: 16.5,
			y2: 7.5
		}),
		/* @__PURE__ */ _jsx("line", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			x1: 16.5,
			y1: 16.5,
			x2: 7.5,
			y2: 7.5
		})
	] })]
});
export { SvgDanger as ReactComponent };
